import { ReactNode } from 'react';
import { GrowlNotificationSupportedVariant } from '@gaiads/telia-react-component-library';

import { NotificationActions } from '../../types';
import * as actionTypes from './actionTypes';

export const showGrowlNotification = (
  text: string,
  variant: GrowlNotificationSupportedVariant,
  autoCloseInMs: number | null = null,
  linkText: string = '',
  linkHref: string = '',
): NotificationActions => {
  return {
    type: actionTypes.SHOW_GROWL_NOTIFICATION,
    text,
    variant,
    linkText,
    linkHref,
    autoCloseInMs,
  };
};

export const showGrowlNotificationTranslated = (
  i18nKey: string,
  variant: GrowlNotificationSupportedVariant,
  autoCloseInMs: number | null = null,
  linkText: string = '',
  linkHref: string = '',
): NotificationActions => {
  return {
    type: actionTypes.SHOW_GROWL_NOTIFICATION_TRANSLATED,
    i18nKey,
    variant,
    linkText,
    linkHref,
    autoCloseInMs,
  };
};

export const closeGrowlNotification = (): NotificationActions => {
  return {
    type: actionTypes.CLOSE_GROWL_NOTIFICATION,
  };
};

export const modalShow = (
  title: string,
  acceptButtonText: string,
  closeButtonText: string,
  onAccept: () => void,
  onClose: () => void,
  children?: ReactNode,
  size?: 'md' | 'lg',
  destructive?: boolean,
  classes?: string,
): NotificationActions => {
  const action: Partial<NotificationActions> = {
    type: actionTypes.MODAL_SHOW,
    title,
    acceptButtonText,
    closeButtonText,
    onAccept,
    onClose,
  };
  if (children) {
    action.children = children;
  }
  if (size) {
    action.size = size;
  }
  if (destructive) {
    action.destructive = destructive;
  }
  if (classes) {
    action.classes = classes;
  }
  return action as NotificationActions;
};

export const modalClose = (): NotificationActions => {
  return {
    type: actionTypes.MODAL_CLOSE,
  };
};
